import * as Yup from "yup";

const createMarkEmployeeAsInactiveSchema = (futureTerminationUnassignment) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return Yup.object().shape({
    reason: Yup.string().required("Reason for marking Inactive is required"),
    endDate: Yup.date()
      .nullable()
      .when("reason", (inactiveReason, schema) => {
        if (futureTerminationUnassignment && !!inactiveReason[0]) {
          return schema.required("End date is required").min(today, "End date must be current or future date");
        }
        return schema.notRequired();
      }),
    comments: Yup.string()
      .nullable()
      .max(260, "Comments cannot exceed 260 characters")
      .when("reason", (inactiveReason, schema) => {
        return inactiveReason[0] == "Other"
          ? schema.required("Comments are required when reason is 'Other'")
          : schema.notRequired();
      }),
  });
};

export default createMarkEmployeeAsInactiveSchema;
